import script from "./ModalBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalBox.vue?vue&type=script&setup=true&lang=js"

import "./ModalBox.vue?vue&type=style&index=0&id=721d9b8d&lang=css"

const __exports__ = script;

export default __exports__